export enum StatisticTerm {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
}

export enum OrganizationStatus {
  ACTIVE = 2,
  DEACTIVATED = 3,
}

export enum EventStatus {
  ACTIVE = 'Active',
  BLOCKED = 'Blocked',
}
